<template>
    <div class="container mt-4">
        <h2 class="mb-4">{{ $t('taskCreate.title') }}</h2>

        <form @submit.prevent="submitForm">
            <div class="mb-3">
                <label for="taskName" class="form-label">{{ $t('taskDetail.titleLabel') }}</label>
                <input type="text" id="taskName" class="form-control" v-model="form.name" required>
            </div>

            <div class="mb-3">
                <label for="taskNotes" class="form-label">{{ $t('browse.description') }}</label>
                <textarea id="taskNotes" class="form-control" v-model="form.notes" rows="3"></textarea>
            </div>

            <div class="mb-3">
                <label for="tenantInput" class="form-label">{{ $t('taskCreate.tenant') }}</label>
                <input type="text" id="tenantInput" class="form-control" v-model="form.tenant">
            </div>

            <div class="mb-3">
                <label for="objectSelect" class="form-label">{{ $t('taskCreate.device') }}</label>
                <v-select id="objectSelect" v-model="form.object_id" :options="objects" :reduce="obj => obj.id"
                    label="name" class="form-control p-0" :placeholder="$t('taskCreate.selectDevice')" />
            </div>

            <div class="mb-3">
                <label for="usersSelect" class="form-label">{{ $t('taskDetail.workers') }}</label>
                <MultiSelect v-model="form.user_ids" :options="users" optionLabel="name" optionValue="id"
                    :placeholder="$t('modal.selectUsers')" class="w-100" display="chip" filter :showToggleAll="false" />
            </div>


            <div class="mb-3">
                <label for="feedbackInput" class="form-label">{{ $t('taskCreate.contactInfo') }}</label>
                <input type="text" id="feedbackInput" class="form-control" v-model="form.feedback">
            </div>

            <button type="submit" class="btn btn-primary" :disabled="actionInProgress">{{ $t('common.save') }}</button>
        </form>
    </div>
</template>

<script>
import axios from '@/services/axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import MultiSelect from 'primevue/multiselect';

export default {
    components: {
        'v-select': vSelect,
        MultiSelect
    },
    data() {
        return {
            form: {
                name: '',
                notes: '',
                tenant: '',
                object_id: '',
                user_ids: [],
                feedback: '',
            },
            objects: [],
            users: [],
            // Submitting twice creates two tasks. The form submits on Enter too,
            // so a held key counts as a double click.
            actionInProgress: false,
        };
    },
    computed: {
        currentUser() {
            const user = localStorage.getItem('user');
            return user ? JSON.parse(user) : null;
        },
        projectId() {
            return this.$route.params.projectId;
        },
    },
    methods: {
        async fetchObjects() {
            try {
                const response = await axios.get(`/projects/${this.projectId}/objects`);
                this.objects = response.data.data;
            } catch (error) {
                console.error('Error fetching objects:', error);
            }
        },
        async fetchUsers() {
            try {
                const response = await axios.get('/users');
                this.users = response.data.data;
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        },
        async submitForm() {
            if (this.actionInProgress) return;
            this.actionInProgress = true;
            try {
                const response = await axios.post(`/projects/${this.projectId}/tasks`, this.form);

                    if (response.status === 200 && response.data?.id) {
                    const newTaskId = response.data.id;
                    this.$root.$refs.globalAlert.showAlert(this.$t('taskCreate.taskAdded'), 'success');
                    this.$router.push(`/tasks/${newTaskId}`);
                } else {
                    this.$root.$refs.globalAlert.showAlert(this.$t('taskCreate.taskAddFailed'), 'danger');
                    console.error('Unexpected response:', response);
                }
            } catch (error) {
                console.error('Error submitting task:', error);
                this.$root.$refs.globalAlert.showAlert(this.$t('taskCreate.taskAddFailed'), 'danger');
            } finally {
                this.actionInProgress = false;
            }
        }

    },
    mounted() {
        this.fetchObjects();
        this.fetchUsers();
    },
};
</script>
